import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Start newly opened pages at their heading while leaving anchors and Back restoration alone. */
export function RouteScrollManager() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    const changedPage = previousPathname.current !== pathname;
    previousPathname.current = pathname;
    if (changedPage && !hash && navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [hash, navigationType, pathname]);

  return null;
}
